// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--618e7";
export var footNote = "Footer-module--footNote--27a30";
export var link = "Footer-module--link--2cb10";
export var nav = "Footer-module--nav--30f67";
export var socialLinks = "Footer-module--socialLinks--87e6b";
export var wrapper = "Footer-module--wrapper--f939d";